import _toConsumableArray from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
import Main from '@/components/main';
import base from './module/base'; // import menu from './module/menu'
// import callCenter from './module/callCenter'

/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String|Number|Function }
 *         显示在侧边栏、面包屑和标签栏的文字
 *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
 *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
 *  hideInBread: (false) 设为true后此级路由将不会出现在面包屑中，示例看QQ群路由配置
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件name属性和路由配置的name一致
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */

export default [{
  path: '/login',
  name: 'login',
  meta: {
    title: 'Login - 登录',
    hideInMenu: true
  },
  component: function component() {
    return import('@/view/login/login.vue');
  }
}, {
  path: '/forget',
  name: 'forget',
  meta: {
    title: '忘记密码',
    hideInMenu: true
  },
  component: function component() {
    return import('@/view/user/forget.vue');
  }
}, {
  path: '/',
  name: 'dphome',
  redirect: '/home'
}, {
  path: '/home',
  name: 'home',
  redirect: '/home2',
  meta: {
    hideInMenu: true,
    title: '首页',
    hideInBread: true,
    notCache: true,
    icon: 'md-home'
  },
  component: function component() {
    return import('@/view/single-page/home/home2');
  },
  children: [{
    path: '/messageList',
    name: 'messageList',
    meta: {
      notCache: true,
      icon: 'md-home'
    },
    component: function component() {
      return import('@/view/single-page/home/messageList/messageList');
    }
  }, {
    path: '/home2',
    name: 'home2',
    meta: {
      notCache: true,
      icon: 'md-home'
    },
    component: function component() {
      return import('@/view/single-page/home/home2.vue');
    }
  }, {
    path: '/policeList',
    name: 'policeList',
    meta: {
      notCache: true,
      icon: 'md-home'
    },
    component: function component() {
      return import('@/view/single-page/home/policeList/policeList');
    }
  }]
}].concat(_toConsumableArray(base), [{
  path: '/console',
  name: '_home',
  redirect: '/project',
  component: Main,
  meta: {
    notCache: true
  },
  children: [{
    path: '/project',
    name: 'project',
    icon: 'ios-apps',
    meta: {
      title: '项目管理',
      notCache: true,
      icon: 'ios-apps'
    },
    component: function component() {
      return import('@/view/console/project/project.vue');
    }
  }, // ...menu,
  {
    path: '/projectManage/:id/:code/:name',
    title: '项目管理',
    name: 'projectManage',
    icon: 'ios-apps',
    meta: {
      title: '项目管理',
      hideInMenu: true,
      notCache: true,
      icon: 'ios-apps',
      hideInBread: false
    },
    component: function component() {
      return import('@/view/console/project/projectList/projectList.vue');
    }
  }]
}, {
  path: '/importFileList/:project_code/:cate_code',
  title: '设备导入列表',
  name: 'importFileList',
  icon: 'ios-apps',
  meta: {
    title: '设备导入列表',
    notCache: true,
    icon: 'ios-apps'
  },
  component: function component() {
    return import('@/view/console/device/deviceImportList.vue');
  }
}, {
  path: '/401',
  name: 'error_401',
  meta: {
    hideInMenu: true
  },
  component: function component() {
    return import('@/view/error-page/401.vue');
  }
}, {
  path: '/500',
  name: 'error_500',
  meta: {
    hideInMenu: true
  },
  component: function component() {
    return import('@/view/error-page/500.vue');
  }
}, {
  path: '*',
  name: 'error_404',
  meta: {
    hideInMenu: true
  },
  component: function component() {
    return import('@/view/error-page/404.vue');
  }
}, {
  path: '/error_store',
  name: 'error_store',
  meta: {
    hideInBread: true
  },
  component: Main,
  children: [{
    path: 'error_store_page',
    name: 'error_store_page',
    meta: {
      icon: 'ios-bug',
      title: '错误收集'
    },
    component: function component() {
      return import('@/view/error-store/error-store.vue');
    }
  }]
}, {
  path: '/error_logger',
  name: 'error_logger',
  meta: {
    hideInBread: true,
    hideInMenu: true
  },
  component: Main,
  children: [{
    path: 'error_logger_page',
    name: 'error_logger_page',
    meta: {
      icon: 'ios-bug',
      title: '错误收集'
    },
    component: function component() {
      return import('@/view/single-page/error-logger.vue');
    }
  }]
}]);